/* eslint-disable @typescript-eslint/no-explicit-any */
import * as React from 'react';

export const Children = (props: React.PropsWithChildren<any>) => {
  return React.Children.map(props.children, child => React.cloneElement(child));
};
